<script>
  export default {
    name: 'headshot-circle',
    props: {
      headshotData: {
        type: Object,
        required: true
      },
      size: {
        type: String,
        default: () => 'md'
      }
    },
    data: () => ({
      styles: {
        sm: {
          imageWidth: 150,
          nameTextSize: 'h5',
          titleTextSize: 'subtitle-2',
          wrapperWidth: 300
        },
        md: {
          imageWidth: 200,
          nameTextSize: 'h3',
          titleTextSize: 'h6',
          wrapperWidth: 350
        }
      }
    })
  }
</script>

<template>
  <v-sheet color="transparent" :height="styles[size].wrapperWidth" :width="styles[size].wrapperWidth" class="wrapper d-flex flex-column align-center justify-center pa-4">
    <v-img
      :src="headshotData.headshot"
      :height="styles[size].imageWidth"
      :max-height="styles[size].imageWidth"
      :max-width="styles[size].imageWidth"
      :width="styles[size].imageWidth"
      class="avatar-image"
    >
    </v-img>
    <h5 class="font-weight-bold primary--text mt-4 text-no-wrap" :class="`text-${styles[size].nameTextSize}`">{{ headshotData.name }}</h5>
    <p class="ma-0" :class="`text-${styles[size].titleTextSize}`">{{ headshotData.title }}</p>
  </v-sheet>
</template>

<style scoped>
  .avatar-image {
    object-fit: cover;
    object-position: center top;
    border-radius: 50%;
    border-style: solid;
    border-width: 0.5em;
    border-image: none 100% / 1 / 0 stretch;
    border-color: var(--v-primary-base);
    /* height: auto; */
    max-height: 18rem;
    max-width: 18rem;
    /* width: 100%; */
  }

  .avatar-image.small {
  }
</style>
